import { SmallSubtitle, SmallTitle } from '@sleepstation/components'
import { HLayout, VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import {
  color,
  mq,
  padding,
  stylesIfPropTrue,
} from '@sleepstation/style-api-helpers'
import { joinWithSpace } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { pipe, prepend } from 'ramda'
import { isNotNil, list } from 'ramda-adjunct'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const AUTHOR_PREFIX = `By`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const toAuthorCredit = pipe(list, prepend(AUTHOR_PREFIX), joinWithSpace)

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
})`
  ${mq(`xSmallOnly`)} {
    min-height: 100%;
    align-items: center;
  }
`

const Footer = styled(VLayout).attrs({
  as: `footer`,
  align: [LAYOUT_ALIGN.LEFT],
  spacing: [0.125],
})`
  ${padding([
    [0, 0.5],
    [0.5, 1],
    [0.5, 0.5],
  ])}
  ${color(`body`)}
`

const Author = styled(SmallSubtitle)`
  ${stylesIfPropTrue(`isVisuallyHidden`, {
    visibility: `hidden`,
  })}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Content = ({ title, authorName }) => {
  const hasAuthor = isNotNil(authorName)
  const authorCredit = hasAuthor && toAuthorCredit(authorName)
  return (
    <Layout>
      <Footer>
        <SmallTitle data-cy="card-title">{title}</SmallTitle>
        <Author isVisuallyHidden={!hasAuthor} data-cy="card-author">
          {authorCredit}
        </Author>
      </Footer>
    </Layout>
  )
}

Content.propTypes = {
  title: PropTypes.string.isRequired,
  authorName: PropTypes.string,
}

Content.defaultProps = {
  authorName: undefined,
}

export default Content
